var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_model"},[_c('iframe',{staticStyle:{"width":"99%","height":"100vh"},attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }